<svg-icon
  *ngIf="isMedia && !card?.userState?.isCompleted"
  class="call-to-action-icon hidden-print"
  src="/assets/icons/play-circle.svg"
  (click)="playMedia($event)"
  (keydown.enter)="playMedia($event)"
  (keydown.space)="playMedia($event)"
  role="button"
  tabindex="0"
  aria-label="Play"></svg-icon>
<svg-icon
  *ngIf="
    card?.userState?.isTracking && isPurposeful && !isMedia && !card?.cardLink.hasLink && !card?.userState?.isCompleted
  "
  class="call-to-action-icon hidden-print"
  src="/assets/icons/checkmark-empty-circle.svg"
  (click)="completeAction($event)"
  (keydown.enter)="completeAction($event)"
  (keydown.space)="completeAction($event)"
  role="button"
  tabindex="0"
  aria-label="Complete"></svg-icon>
<kp-call-to-action
  *ngIf="!isMedia && card?.cardLink?.hasLink && (!card?.userState?.isCompleted || card.isQuestCard)"
  class="hidden-print"
  (click)="linkClicked($event)"
  (keydown.enter)="linkClicked($event)"
  (keydown.space)="linkClicked($event)"
  [link]="card?.cardLink"
  [callToAction]="card?.callToAction"
  [card]="card"
  [isQuestCard]="card?.isQuestCard"
  [requestType]="requestType"
  [returnUrl]="returnUrl"
  [showCompactView]="true"></kp-call-to-action>
<svg-icon
  *ngIf="isPurposeful && card?.userState?.isCompleted && !card.isQuestCard"
  class="call-to-action-icon hidden-print"
  src="/assets/icons/checkmark.svg"
  (click)="unCompleteAction($event)"
  (keydown.enter)="unCompleteAction($event)"
  (keydown.space)="unCompleteAction($event)"
  role="button"
  tabindex="0"
  aria-label="Un-complete"></svg-icon>
